import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  clientName?: string;
}

export const Breadcrumb = ({ clientName }: BreadcrumbProps) => {
  const { t } = useTranslation('viewClientModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumbs.clients'), path: '/clients' },
      { label: clientName || t('breadcrumbs.clientDetail') },
    ],
    [t, clientName],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
